import Vue from 'vue'
import axios from 'axios'
import store from './../store'
import md5 from 'js-md5'
import { Notification } from 'element-ui'

const http = axios.create({
  timeout: 15000 // 请求超时
})

http.interceptors.request.use(
  requestConfig => {
    const token = store.state.user.token
    if (token) {
      requestConfig.headers.Authorization = store.state.user.token
    }
    return requestConfig
  },
  error => Promise.reject(error)
)
http.interceptors.response.use(
  resp => {
    if (resp.data.status === 99101 || resp.data.status === 40301) {
      store.dispatch('resultsToken')
      Vue.prototype.$login.open(true)
      setTimeout(() => {
        Notification({
          title: '警告',
          message: '登录过期,请重新登录',
          type: 'warning',
          duration: '2000',
          showClose: false
        })
      }, 0)
      return resp
    } else {
      return resp
    }
  },
  error => {
    window.console.error(error)
  }
)

export default http

export function get(url, params = {}) {
  return http({
    method: 'get',
    url,
    params
  })
}

export function getSign(url, params = {}) {
  const timestamp = new Date().getTime()
  const signSecretkey = 'xjfmobile'
  const sign = md5(timestamp + signSecretkey)
  return http({
    method: 'get',
    url,
    params,
    headers: { timestamp: timestamp, sign: sign }
  })
}

export function post(url, data = {}, params = {}) {
  return http({
    method: 'post',
    url,
    data,
    params
  })
}

export function put(url, data = {}, params = {}) {
  return http({
    method: 'put',
    url,
    data,
    params
  })
}

export function _delete(url, params = {}) {
  return http({
    method: 'delete',
    url,
    params
  })
}
